import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import Image from 'next/image'
import Link from 'next/link'
import { LinkButton } from '../ui'
import { HomeContentBlock, HomeParagraph, HomeSection, HomeTitle } from './base'

const Hero = () => {
  return (
    <HomeSection padding='xl' layout='grid'>
      <HomeContentBlock>
        <Badge
          variant='outline'
          className='h-10 uppercase rounded-full text-xs font-semibold text-neutral-800 border-neutral-800 px-6'
        >
          Purpose-built for PR & Media Teams
        </Badge>

        <div className='space-y-2'>
          <HomeTitle as='h1' size='hero'>
            Revolutionizing how sports PR teams communicate with the media
          </HomeTitle>

          <HomeParagraph>
            Eliminate email chaos. Create Posts. Analyze content. Control which media members receive your materials.
            Grant access to your PR team members — all in one place.
          </HomeParagraph>
        </div>

        <div className='w-fit'>
          <LinkButton href='/signup' className='bg-neutral-800 text-white hover:bg-neutral-700'>
            Get Started
          </LinkButton>
        </div>
      </HomeContentBlock>

      <div className='relative flex items-center justify-center'>
        <Image
          priority
          src='/images/home/hero_img.webp'
          alt='Laptop'
          width={1000}
          height={1000}
          className='w-full h-auto max-w-lg lg:max-w-none'
        />
      </div>
    </HomeSection>
  )
}

export default Hero
